import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import UserInfo from "./user/UserInfo";
import OpenPagesList from "./OpenPagesList";
import "../../styles/open-pages/open-pages.css";
import "../../styles/pt/pt-trials.css";
import HelmetWrapper from "../../HelmetWrapper";
// import { useSelector } from "react-redux";
import Notifications from "../push-notifications/Notifications";

const OpenPages = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userInfo, decryptedText } = location.state || {};
  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    if (!decryptedText) {
      navigate("/open-access");
    }
  }, [decryptedText]);

  return (
    <HelmetWrapper title="WTF: Open Page Management">
      <Container className="bg-cloud-k gobal-container" fluid>
        {decryptedText && !isIOS() && (
          <Notifications authData={decryptedText} />
        )}

        <UserInfo userData={userInfo} />
        {/* {isNotificationDenied === "denied" && (
          <Alert variant={"danger"} className="mt30">
            Notification permission is denied. Unable to display desktop
            notifications.
          </Alert>
        )} */}

        <OpenPagesList decryptedText={decryptedText} />
      </Container>
    </HelmetWrapper>
  );
};

export default OpenPages;